import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.il.js';
import 'cleave.js/dist/addons/cleave-phone.gb.js';
import {isValid, toNormalised} from "postcode";

//Used with the jquery validate plugin  - set in the validation partial script
window.isValid = isValid;

class InputFormatting {
    constructor() {
    }

    #moneyInputClass =  ".money-input";

    applyAll(){
        this.formatUKPhoneNumbers();
        this.formatEUPhoneNumbers();
        this.formatMoneyInputs();
        this.formatPoundMoneyInputs();

        let app = this;

        //Remove the formatting that prevent backend parsing
        $('form').submit(function() {
            $(app.#moneyInputClass).val($(app.#moneyInputClass).val().replace('£',''));
            return true;
        });
    }

    formatUKPhoneNumbers(){
        let phoneInputs = $('.phone-input-uk');
        if(phoneInputs.length > 0) {
            $(phoneInputs).each(function (index, item) {
                let cleave_phone_uk = new Cleave(item, {
                    phone: true,
                    phoneRegionCode: 'GB'
                });
            });
        }
    }

    formatEUPhoneNumbers(){
        let euPhoneInputs = $('.phone-input-eu');
        if(euPhoneInputs.length > 0) {
            $(euPhoneInputs).each(function (index, item) {
                let cleave_phone_eu = new Cleave(item, {
                    phone: true,
                    phoneRegionCode: 'DE'
                });
            });
        }
    }

    formatMoneyInputs() {
        let moneyInputs= $('.money-input')
        if(moneyInputs.length > 0) {
            $(moneyInputs).each(function (index, item) {
                let cleave_money = new Cleave(item, {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                    prefix: '£',
                    numeralDecimalMark: '.',
                    noImmediatePrefix: false
                });
            });
        }
    }

    formatPoundMoneyInputs() {
        let moneyInputsPounds = $('.money-pounds-input');
        if(moneyInputsPounds.length > 0) {
            $(moneyInputsPounds).each(function (index, item) {
                let cleave_money = new Cleave(item, {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                    prefix: '£',
                    suffix: '.00',
                    noImmediatePrefix: false
                });
            });
        }
    }

    formatUKPostcode() {
        $('.postcode').each(function (){
            $(this).blur(function (){
                let postcode = $(this).val();
                if(isValid(postcode))
                    $(this).val(toNormalised(postcode));
            });
        });
    }
}

export default InputFormatting;